import { render, staticRenderFns } from "./BaseTextarea.vue?vue&type=template&id=25e7d597"
import script from "./BaseTextarea.vue?vue&type=script&lang=js"
export * from "./BaseTextarea.vue?vue&type=script&lang=js"
import style0 from "./BaseTextarea.vue?vue&type=style&index=0&id=25e7d597&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports